import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AdvancedSettings } from '../models/advanced-settings';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdvancedSettingsService {

  private acceptedLevels: string[] = [];

  private acceptedSources: string[] = [];

  constructor(private http: HttpClient) { }

  public get levels() {
    return this.acceptedLevels;
  }

  public setLevels(levels: string[]) {
    this.acceptedLevels = levels;
  }

  public get sources() {
    return this.acceptedSources;
  }

  public setSources(sources: string[]) {
    this.acceptedSources = sources;
  }

  public getAdvancedSettings() {
    return this.http.get(`${environment.apiUrl}AccountMetadata/settings`) as Observable<AdvancedSettings>;
  }

  public saveAdvancedSettings(body: any) {
    return this.http.put(`${environment.apiUrl}AccountMetadata/settings`, body);
  }

  public getCmsValue() {
    return this.http.get(`${environment.apiUrl}AccountMetadata/settings/cms`) as Observable<{ type: string, ucVersion: string }>;
  }
  
  public getSwapOfferConfigs(): Observable<any> {
    return this.http.get(`${environment.apiUrl}AccountMetadata/swapConfig`) as any;
  }

  public saveSwapOfferConfigs(body: any): Observable<any> {
    return this.http.put(`${environment.apiUrl}AccountMetadata/swapConfig`, body) as any;
  }
}
